import {
  init as SentryInit,
  browserTracingIntegration as SentryBrowserTracingIntegration,
  replayIntegration as SentryReplayIntegration,
} from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

if (
  import.meta.env.SENTRY_ENVIRONMENT === 'production' ||
  import.meta.env.SENTRY_ENVIRONMENT === 'staging' ||
  import.meta.env.SENTRY_ENVIRONMENT === 'development'
) {
  SentryInit({
    dsn: 'https://460804b4da2d9a6afeb88589e11c8527@sentry.moveo.technology/14',
    integrations: [
      SentryBrowserTracingIntegration(),
      SentryReplayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1,
    release: import.meta.env.NG_APP_VERSION,
    dist: import.meta.env.NG_APP_VERSION,
    sampleRate: 1,
    replaysSessionSampleRate:
      import.meta.env.SENTRY_ENVIRONMENT === 'production' ? 1.0 : 0,
    replaysOnErrorSampleRate: 1,
    enableLogs: true,
    tracePropagationTargets: [
      'localhost',
      new RegExp(import.meta.env.NG_APP_MDS_URL),
      new RegExp(import.meta.env.NG_APP_MDS_AUTH),
    ],
    environment: import.meta.env.SENTRY_ENVIRONMENT,
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
